import React, { Component } from 'react'
import PurchaseForm from '../../Screens/PurchaseForm/PurchaseForm'
import './PurchaseButton.css'
import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import { createOrderAsShopify } from '../../CreateOrder/CreateOrderAsShopify';
import ThankYouPage from '../../Screens/ThankYouPage/ThankYouPage';
import UpsellPage from '../../Screens/UpsellPage/UpsellPage';
import { storeData } from '../../storeData';
import TiktokPixel from 'tiktok-pixel';
import { onlyOnePurchaseButtonVisible } from '../../Screens/Product/Scripts/onlyOnePurchaseButtonVisible';

export default class PurchaseButton extends Component {

  state = {
    from_cart: this.props.from_cart,
    showLoader: false,
    showPurchaseFormModal:false,
    showUpsellPage: false,
    store_product_data: null,
    showThankYouPage:false,
    thankYouPageData: null,
  }

  componentDidMount=()=>{
    const {useAddEventListener} = this.props
    if (useAddEventListener) {
      onlyOnePurchaseButtonVisible()
    }
  }

  ToggleShowPurchaseFormModal = () => {
    this.setState({ showPurchaseFormModal: !this.state.showPurchaseFormModal})
  }

  createOrder = async (e) => {
    e.preventDefault()
    const {ProductData, selectedPackData, selectedVariants} = this.props
    const {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code} = this.props
    const {UTM_params, discount_code} = this.props
    const {setShowToast, free_shipping, shipping_cost, cart_items, add_to_cart, remove_from_cart } = this.props
    
    this.setState({showLoader: true})
    let res = await createOrderAsShopify(
      {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note},
      cart_items,
      false,
      null,
      null,
      null,
      null,
      null,
      UTM_params,
      discount_code,
      free_shipping,
      shipping_cost,
      shipping_type_code
    )
    
    // let store_with_upsell = storeData().products[0].product_with_upsell
    // let store_with_upsell = false

    // 06/06/25 ---------------------------------------
    const store_product_data = ProductData? storeData().products.filter((item) => item.product_id_for_sell === ProductData.id)[0] : null
    let store_with_upsell = store_product_data?.product_with_upsell || false
    // 06/06/25 ---------------------------------------


    if(res.success === true){
      if(store_with_upsell === true){
        this.setState({
          showLoader: false,
          showUpsellPage: true,
          store_product_data,
          upsellPageData: {order_number: res.response.orderData.order_number, order_data: res.response.orderData, store_product_data},
          thankYouPageData: {order_number: res.response.orderData.order_number, order_data: res.response.orderData}
        })
      } else {
        this.setState({
          showLoader: false,
          showThankYouPage: true,
          thankYouPageData: {order_number: res.response.orderData.order_number, order_data: res.response.orderData}
        })
      } 
    }
  }

  createOrderWithUpsell = async (e, upsellProductData, upsellItem, selectedVariantsForUpsellItem) => {
    e.preventDefault()
    const {upsellPageData} = this.state
    const {ProductData, selectedPackData, selectedVariants} = this.props
    const {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code} = this.props
    const {UTM_params, discount_code} = this.props
    const {free_shipping, shipping_cost, cart_items, add_to_cart, remove_from_cart } = this.props

    // console.log(upsellPageData)

    this.setState({showLoader: true})
    let res = await createOrderAsShopify(
      {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note},
      cart_items,
      false,
      true,
      upsellProductData,
      upsellItem,
      upsellPageData,
      selectedVariantsForUpsellItem,
      UTM_params,
      discount_code,
      free_shipping,
      shipping_cost,
      shipping_type_code
    )
    if(res.success === true){
      this.setState({
        showUpsellPage: false,
        showThankYouPage: true,
        thankYouPageData: {order_number: res.response.orderData.order_number, order_data: res.response.orderData}
      })
    }
  }

  declineUpsell = (e) => {
    this.setState({
      showUpsellPage: false,
      showThankYouPage: true,
    })
  }

  createDraftOrder = async (e) =>{
    // window.fbq('track', 'AddToCart');
    // TiktokPixel.track('AddToCart', {
    //   content_type: 'product',
    //   content_id: 'ID_del_producto',
    //   currency: 'COP',
    //   value: 0,
    //   content_name: 'Nombre_del_producto',
    //   quantity: 1,
    // });
    
    const {selectedVariants, showLoader, ProductData, createOrder, readData, getSelectedPackData, getSelectedVariants, selectedPackId, selectedPackData,  quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code} = this.props
    const {UTM_params, discount_code} = this.props
    const {free_shipping, shipping_cost, cart_items, add_to_cart, remove_from_cart } = this.props

    let res = await createOrderAsShopify(
      {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note},
      cart_items,
      true,
      null,
      null,
      null,
      null,
      null,
      UTM_params,
      discount_code,
      free_shipping,
      shipping_cost,
      shipping_type_code
    )
  }

  onModalClose = (e) =>{
    const {resetAll} = this.props
    if (this.state.showThankYouPage===true) {
      resetAll()
    }
    this.setState({showPurchaseFormModal: false, showThankYouPage:false, showUpsellPage:false, showLoader:false})
    return true;
  }

  componentDidUpdate=(prevProps, prevState)=>{
    const {cart_items, remove_from_cart} = this.props
    if (prevProps.cart_items.length > 0 && cart_items.length < 1) {
      this.setState({showPurchaseFormModal: false})
    }

    if (prevState.showPurchaseFormModal === true && this.state.showPurchaseFormModal===false) {
      const first_item = cart_items[0]
      if (first_item?.automatic_added === true) {
        remove_from_cart(first_item)
      }
    }
  }

  render() {
    const {from_cart, showLoader, showPurchaseFormModal, showUpsellPage, showThankYouPage, thankYouPageData} = this.state
    const {readData, quantity, discount_code, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code} = this.props
    const {ProductData, getSelectedPackData, getSelectedVariants, selectedPackId, selectedPackData, selectedVariants} = this.props
    const {product_data_for_upsell} = this.props
    const {cart_items, add_to_cart, remove_from_cart } = this.props
    const {animation_disabled, resetAll, discount_value, setDiscountValue, setShowToast, free_shipping, shipping_cost, bulk_unit_discount, units, min_qty_to_get_bulk_discount} = this.props
    
    return (
      <div>
        
        <button onClick={this.ToggleShowPurchaseFormModal} className={`${from_cart!==true?'PurchaseButton':'PurchaseButtonForCart'} ${animation_disabled===true? "" : "PurchaseButton_animation"}`} type="button">
          Comprar ahora - Pagar al recibir
        </button>

        <PureModal
          header="Checkout"
          width='94%'
          isOpen={showPurchaseFormModal}
          closeButton="Cerrar"
          closeButtonPosition="header"
          onClose={this.onModalClose}
        >
          {/* {showUpsellPage!==false && showThankYouPage!==false? // eliminar al terminar upsell page */}
          {showUpsellPage===false && showThankYouPage===false? // descomentar al terminar upsell page 
          <PurchaseForm
          discount_value={discount_value}
          setDiscountValue={setDiscountValue}
          setShowToast={setShowToast}
          from_cart={from_cart}
          cart_items={cart_items}
          add_to_cart={add_to_cart}
          remove_from_cart={remove_from_cart}
          showLoader={showLoader}
          ProductData={ProductData}
          readData={readData}
          getSelectedPackData={getSelectedPackData}
          getSelectedVariants={getSelectedVariants}
          selectedVariants={selectedVariants}
          selectedPackId={selectedPackId}
          selectedPackData={selectedPackData}
          createOrder={this.createOrder}
          createDraftOrder={this.createDraftOrder}
          quantity={quantity}
          discount_code={discount_code}
          first_name={first_name}
          last_name={last_name} 
          phone_number={phone_number}
          address1={address1}
          address2={address2}
          province={province}
          city={city}
          contact_email={contact_email} 
          note={note}
          shipping_type_code={shipping_type_code}
          free_shipping={free_shipping}
          shipping_cost={shipping_cost}
          bulk_unit_discount={bulk_unit_discount}
          units={units}
          min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount}
          />

          :

          showUpsellPage===true? // descomentar al terminar upsell page
          // showUpsellPage===false? // eliminar al terminar upsell page
          <UpsellPage 
          showLoader={showLoader}
          createOrderWithUpsell={this.createOrderWithUpsell} 
          declineUpsell={this.declineUpsell} 
          product_data_for_upsell={product_data_for_upsell}
          store_product_data={this.state.store_product_data}
          first_name={first_name}
          />

          :

          <ThankYouPage
          shipping_type_code={shipping_type_code}
          free_shipping={free_shipping}
          shipping_cost={shipping_cost}
          discount_value={discount_value}
          setDiscountValue={setDiscountValue}
          thankYouPageData={thankYouPageData}
          ProductData={ProductData}
          selectedPackData={selectedPackData}
          quantity={quantity} 
          first_name={first_name}
          last_name={last_name} 
          phone_number={phone_number}
          address1={address1}
          address2={address2}
          province={province}
          city={city}
          contact_email={contact_email} 
          note={note}
          />
          }

        </PureModal>



      </div>
    )
  }
}
